import styled from 'styled-components'

const CardBody = styled.div`
--tw-text-opacity: 1;
color: rgba(51,51,51,var(--tw-text-opacity));
padding-top: 2.5rem;
padding-left: .5rem;
padding-right: .5rem;
justify-content: center;
flex-direction: row;
display: flex;
font-family: sans-serif;
@media (min-width: 768px)
    {
    padding-left: 2rem;
    padding-right: 2rem;
    }
`
const Card = styled.div`
    --tw-shadow: 0 20px 25px -5px rgba(0,0,0,0.1),0 10px 10px -5px rgba(0,0,0,0.04);
    box-shadow: var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow);
    padding: 2rem;
    border: 1px solid rgba(0,0,0,.1);
    border-radius: .5rem;
    align-items: flex-start;
    flex-wrap: wrap;
    flex-direction: row;
    width: 100%;
    display: flex;
    @media (min-width: 1024px)
    {
    width: 75%;
    }
`

const ImgBox = styled.div`
 border: 1px solid rgba(0,0,0,.1);
border-radius: .5rem;
overflow: hidden;
width: 8rem;
height: 8rem;
margin-bottom: 1rem;
margin-right: 2.5rem;
`
const ContentBox = styled.div`
width: 100%;
@media (min-width:768px){
    flex: 1 1 0%
}
`

const Content = styled.p`
letter-spacing: -0.025em;
font-weight: 600;
font-size: 1.25rem;
line-height: 1.75rem;
margin:0;
margin-bottom: 1rem;
`
const Founder = styled.p`
opacity: .75;
margin: 0;
`
export const PersonCard = ({img,information,founder,designation}) => {
    
    return(
       <CardBody>
             <Card>
                 <ImgBox>
                    <img style={{display:'block',verticalAlign:"middle",maxWidth:"100%",height:"auto"}} src={img} alt="Founder Image" />
                 </ImgBox>
                 <ContentBox>
                   <Content>
                      {`"${information}"`}
                   </Content>
                   <Founder>
                    {founder}
                    <br />
                    {designation}
                   </Founder>
                 </ContentBox>
             </Card>
        </CardBody>
    )
}